var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.menuList[_vm.routeIndex]),function(item,index){return _c('div',{key:index},[_c('div',{staticStyle:{"margin-bottom":"4px"}},[_c('router-link',{attrs:{"to":item.path,"active-class":"active"}},[_vm._v(_vm._s(item.name))])],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }